"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _dropdown = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown"));

var _textField = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/text-field"));

var _NestedDropdownHeader = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown/NestedDropdownHeader"));

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

var _Add = _interopRequireDefault(require("@insided/destination/icons/Add"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _UsersPlus = _interopRequireDefault(require("@insided/destination/modules/Customization/icons/UsersPlus"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SegmentsSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SegmentsSelector, _Component);

  var _super = _createSuper(SegmentsSelector);

  function SegmentsSelector() {
    var _this$props$selectedP, _this$props$selectedP2;

    var _this;

    (0, _classCallCheck2.default)(this, SegmentsSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "segmentIdMapping", _this.props.widgetPersonalisationOptions.reduce(function (acc, option) {
      acc[option.segmentId] = option;
      return acc;
    }, {}));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      searchTextForSegment: '',
      isGuestUserSelected: _this.props.selectedPersonalisationFilters !== null && _this.props.selectedPersonalisationFilters.isGuestUserSelected,
      selectedSegments: (_this$props$selectedP = _this.props.selectedPersonalisationFilters) !== null && _this$props$selectedP !== void 0 && _this$props$selectedP.segments ? (_this$props$selectedP2 = _this.props.selectedPersonalisationFilters) === null || _this$props$selectedP2 === void 0 ? void 0 : _this$props$selectedP2.segments.filter(function (segmentId) {
        return Object.keys(_this.segmentIdMapping).includes(String(segmentId));
      }) : []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectionUpdate", function () {
      _this.props.onWidgetVisibilityUpdated(_this.state.isGuestUserSelected, _this.state.selectedSegments);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSegmentSelected", function (selectedSegment) {
      var selectedSegmentsSet = new Set(_this.state.selectedSegments);

      if (selectedSegmentsSet.has(selectedSegment)) {
        selectedSegmentsSet.delete(selectedSegment);
      } else {
        selectedSegmentsSet.add(selectedSegment);
      }

      _this.setState({
        selectedSegments: Array.from(selectedSegmentsSet)
      }, _this.onSelectionUpdate);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRemoveSelectedSegment", function (segmentId) {
      var selectedSegmentsSet = new Set(_this.state.selectedSegments);
      selectedSegmentsSet.delete(segmentId);

      _this.setState({
        selectedSegments: Array.from(selectedSegmentsSet)
      }, _this.onSelectionUpdate);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onGuestUserSelectionUpdated", function (isGuestUserSelected) {
      _this.setState({
        isGuestUserSelected: isGuestUserSelected
      }, _this.onSelectionUpdate);
    });
    return _this;
  }

  (0, _createClass2.default)(SegmentsSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          widgetPersonalisationOptions = _this$props.widgetPersonalisationOptions,
          controlUrl = _this$props.controlUrl;
      var _this$state = this.state,
          searchTextForSegment = _this$state.searchTextForSegment,
          isGuestUserSelected = _this$state.isGuestUserSelected,
          selectedSegments = _this$state.selectedSegments;
      var widgetPersonalisationOptionsList = (widgetPersonalisationOptions !== null && widgetPersonalisationOptions !== void 0 ? widgetPersonalisationOptions : []).reduce(function (updatedPersonalisationList, option) {
        var groupName = option.groupName,
            segmentId = option.segmentId,
            segmentName = option.segmentName;

        if (!updatedPersonalisationList[groupName]) {
          updatedPersonalisationList[groupName] = [];
        }

        updatedPersonalisationList[groupName].push({
          segmentId: segmentId,
          segmentName: segmentName
        });
        return updatedPersonalisationList;
      }, {}); // Items are array of array. Each array keeps one group of segments. each object includes segmentId, groupName, title and children

      var items = Object.keys(widgetPersonalisationOptionsList).map(function (groupName) {
        // Filter out the objects if segmentName of the object does not contain the searchTextForSegment
        var filteredWidgetPersonalisationOptionsList = (widgetPersonalisationOptions !== null && widgetPersonalisationOptions !== void 0 ? widgetPersonalisationOptions : []).reduce(function (updatedPersonalisationList, option) {
          var groupName = option.groupName,
              segmentId = option.segmentId,
              segmentName = option.segmentName;

          if (!updatedPersonalisationList[groupName]) {
            updatedPersonalisationList[groupName] = [];
          }

          if (segmentName.toLowerCase().includes(searchTextForSegment.toLowerCase())) {
            updatedPersonalisationList[groupName].push({
              segmentId: segmentId,
              segmentName: segmentName
            });
          }

          return updatedPersonalisationList;
        }, {});

        if (filteredWidgetPersonalisationOptionsList[groupName].length === 0) {
          return [];
        }

        return filteredWidgetPersonalisationOptionsList[groupName].map(function (segment) {
          return {
            id: segment.segmentId,
            groupName: groupName,
            title: segment.segmentName,
            children: []
          };
        });
      });
      return (0, _preact.h)("div", {
        className: "widgets-visibility__segments-configurator"
      }, (0, _preact.h)("p", null, "Choose segments to include"), (0, _preact.h)(_Checkbox.default, {
        label: (0, _preact.h)("span", null, (0, _preact.h)("strong", null, "Guest users"), (0, _preact.h)("span", {
          className: "text--meta"
        }, " (Visible to users who are not signed in)")),
        customClass: "widget-visibility-selector--guest-user-checkbox",
        onUpdate: this.onGuestUserSelectionUpdated,
        checked: isGuestUserSelected
      }), !widgetPersonalisationOptions.length && (0, _preact.h)("div", {
        className: "widget-configuration_info-box"
      }, (0, _preact.h)("b", null, "You do not have any segments yet"), (0, _preact.h)("p", null, "You can create segments by applying filters to the", ' ', (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("".concat(controlUrl, "/users/overview")),
        target: "_blank",
        rel: "noreferrer"
      }, "User overview"), ' ', "and saving that as segment.")), widgetPersonalisationOptions.length > 0 && (0, _preact.h)(_dropdown.default, {
        size: "full-width",
        openAlwaysOnTriggerClick: true,
        textButtonStyle: {
          width: '100%',
          marginBottom: '8px'
        },
        customHeight: "250px",
        popupName: "widgets-visibility_segments-selection",
        trigger: (0, _preact.h)("div", {
          className: "widgets-visibility_segments-add"
        }, (0, _preact.h)("span", {
          className: "widgets-visibility_segments-add--icon"
        }, (0, _preact.h)(_Add.default, null)), (0, _preact.h)(_textField.default, {
          isControl: true,
          size: "fullWidth",
          name: "segment-selection",
          placeholder: "Search for segments",
          ariaLabel: "Search for segments",
          id: "widgets__personalisation",
          onKeyUp: function onKeyUp(newText) {
            return _this2.setState({
              searchTextForSegment: newText
            });
          }
        }))
      }, items.some(function (item) {
        return item.length;
      }) ? // Display the segments in the dropdown if at least there is one group that matches the search text
      items.filter(function (item) {
        return item.length;
      }).map(function (item) {
        var groupName = item[0].groupName;
        return (0, _preact.h)("div", {
          key: groupName
        }, (0, _preact.h)(_NestedDropdownHeader.default, null, groupName), (0, _preact.h)(_NestedDropdown.default, {
          labelId: "segment-selection",
          items: item,
          onMultiSelect: function onMultiSelect(selectedSegment) {
            return _this2.onSegmentSelected(selectedSegment);
          },
          selectedItems: selectedSegments.map(function (selectedSegment) {
            return String(selectedSegment);
          }),
          depth: 1
        }));
      }) : (0, _preact.h)(_dropdown.DropdownItem, {
        key: "no-segment-found"
      }, (0, _preact.h)("span", {
        className: "text--meta"
      }, "No segments found. Please create segments in Control."))), widgetPersonalisationOptions.length > 0 && (0, _preact.h)("div", {
        className: "widget-personalisation_selected-segments-list"
      }, isGuestUserSelected && (0, _preact.h)("div", {
        className: "widget-personalisation_selected-segments-list--item"
      }, (0, _preact.h)("div", {
        className: "selected-segment-item-info"
      }, (0, _preact.h)(_UsersPlus.default, {
        width: 24,
        height: 24
      }), (0, _preact.h)("span", null, "Guest users"))), selectedSegments.map(function (segmentId) {
        return (0, _preact.h)("div", {
          key: segmentId,
          className: "widget-personalisation_selected-segments-list--item"
        }, (0, _preact.h)("div", {
          className: "selected-segment-item-info"
        }, (0, _preact.h)(_UsersPlus.default, {
          width: 24,
          height: 24
        }), (0, _preact.h)("span", null, _this2.segmentIdMapping[segmentId].segmentName)), (0, _preact.h)("button", {
          className: "selected-segment-item-remove",
          onClick: function onClick() {
            return _this2.onRemoveSelectedSegment(segmentId);
          }
        }, (0, _preact.h)(_Close.default, {
          width: 24,
          height: 24
        })));
      })));
    }
  }]);
  return SegmentsSelector;
}(_preact.Component);

exports.default = SegmentsSelector;